<template lang="pug">
    v-app#app
        NavDrawer(v-if='showToolbarAndNavDrawer' ref="drawer")
        Toolbar(title="iMemo" v-if='showToolbarAndNavDrawer')
        AlertExpired(:expirationDate="tokenExpiredDate")
        router-view
        Footer(v-if="$route.name !== 'Login' && $route.name !== 'Logout'")
        Loader
</template>

<script>
import NavDrawer from "./components/NavDrawer.vue";
import Toolbar from "./components/Toolbar.vue";
import AlertExpired from "./components/AlertExpired.vue";
// import {bus} from "./main";
import Footer from "./components/Footer.vue";
import Loader from "./components/partials/_loader.vue";

export default {
  name: "app",
  components: {
    AlertExpired,
    NavDrawer,
    Toolbar,
    Footer,
    Loader
  },
  computed: {
    showToolbarAndNavDrawer() {
      if (this.$route.path.match(/^\/page-approval/g)) return false;
      if (this.$route.name == 'Report Pending Approval') return false;
      if (!this.$store.getters.isAuthenticated) return false;
      if (this.$route.name == 'IM Approval') return false;
      if (this.$route.path.match(/^\/im-approve/g)) return false;
      return true;
    },
    tokenExpiredDate() {
      return this.$store.getters.getTokenExpiredDate;
    }
  },
  created() {
    let VUE_APP_API = document.createElement('p')
    VUE_APP_API.setAttribute('id', 'SERVER_URL')
    VUE_APP_API.setAttribute('data-url', process.env.VUE_APP_API)
    document.body.appendChild(VUE_APP_API)
  },
  
};
</script>

<style>
  .vti__country-code{
    display: none !important;
  }
  .blue-primary{
    background: #D42A2A !important;
    color: #fff !important;
  }

  .v-icon.blue-dark {
    color: #1976D2 !important;
  } 

  .color-primary{
    color: #1976D2 !important;
  }

  .color-primary:hover{
    color: #fff !important;
    background: #338FEA !important;
  }

  .blue-secondary{
    background: #1976D2 !important;
    color: #fff !important;
  }

  .blue-secondary:hover{
    background: #338FEA !important;
  }

  .toasted{
    font-family: roboto;
  }

  .empty__title{
    font-size: 16px;
    font-weight: 500;
    color: #000000;
  }

  .empty__subtitle{
    font-size: 14px;
    color: #667085;
  }
  
  .toasted .primary.info, .toasted.toasted-primary.info {
      background: #1976D2 !important;
  }

  .toasted .primary.error, .toasted.toasted-primary.error {
      background: #FF5252 !important;
  }

  .toasted .primary.success, .toasted.toasted-primary.success {
      background: #3CCA5C !important;
  }
</style>

